<app-tile
  [title]="title"
  [hasDivider]="true"
  [isLoading]="true"
  [isMock]="true"
>
</app-tile>
